// extracted by mini-css-extract-plugin
export default {"footer_others":"styles_footer_others__FrBtj","footer_navigation_link":"styles_footer_navigation_link__KOfWO"};